/**
 * This file is shared between pok-core & pok-web
 * If you have to change it then do it in pok-core and run yarn get:validation-schemas @pok-web
 */

import { tk } from './tk';

export enum DictionariesShortnameEnum {
  ContactDefault = 'DF',
  ContactRodo = 'SR',
  ContactFinance = 'FI',
}

export enum ObjectEnum {
  Project = 'Project',
  Invoice = 'Invoice',
  CorrectInvoice = 'CorrectInvoice',
  FormalCorrectInvoice = 'FormalCorrectInvoice',
}

export enum PersonalLanguageType {
  Projects = 'Projects',
  Campaigns = 'Campaigns',
}

export const PersonalLanguageTypeObj = {
  Projects: tk.enum.projects,
  Campaigns: tk.enum.campaigns,
};

export enum LanguageType {
  PL = 'PL',
  EN = 'EN',
}

export const LanguageTypeTextObj = {
  PL: tk.enum.pl,
  EN: tk.enum.en,
};

export enum PositionTypeEnum {
  Standard = 'Standard',
  Commission = 'Commission',
  TransferredCommission = 'TransferredCommission',
  TechnicalCost = 'TechnicalCost',
}

export const PositionTypeObj = {
  Standard: tk.enum.standard,
  Commission: tk.enum.commission,
  TransferredCommission: tk.enum.transferredCommission,
  TechnicalCost: tk.enum.technicalCost,
};

export enum ApplicationTypeEnum {
  Position = 'Position',
  Purchaser = 'Purchaser',
  DictionaryValue = 'DictionaryValue',
  Brand = 'Brand',
  Permission = 'Permission',
}

export const ApplicationTypeObj = {
  Position: tk.enum.position,
  Purchaser: tk.enum.purchaser,
  DictionaryValue: tk.enum.dictionaryValue,
  Brand: tk.enum.brand,
  Permission: tk.enum.permission,
};

export enum ApplicationStatusEnum {
  New = 'New',
  Completed = 'Completed',
  Rejected = 'Rejected',
}

export const ApplicationStatusObj = {
  New: tk.enum.new,
  Completed: tk.enum.completed,
  Rejected: tk.enum.rejected,
};

export enum EmailStatus {
  NotSent = 'NotSent',
  Sent = 'Sent',
  Error = 'Error',
}

export const EmailStatusObj = {
  NotSent: tk.enum.notSent,
  Sent: tk.enum.sent,
  Error: tk.enum.error,
};

//TODO: usunac
export enum CurrencyIsoTypeEnum {
  PLN = 'PLN',
  USD = 'USD',
  EUR = 'EUR',
  CZK = 'CZK',
  RUB = 'RUB',
  HUF = 'HUF',
  GBP = 'GBP',
  BGN = 'BGN',
  RON = 'RON',
  HRK = 'HRK',
  AUD = 'AUD',
}

export enum ProjectEstimatesStatusEnum {
  New = 'New',
  AcceptedByClient = 'AcceptedByClient',
  ReadyForInvoice = 'ReadyForInvoice',
  Invoiced = 'Invoiced',
  Corrected = 'Corrected',
  Settled = 'Settled',
  Cancelled = 'Cancelled',
  Withdrawn = 'Withdrawn',
}

export const ProjectEstimatesStatusObj = {
  New: tk.enum.new,
  AcceptedByClient: tk.enum.acceptedByClient,
  ReadyForInvoice: tk.enum.readyForInvoice,
  Invoiced: tk.enum.invoiced,
  Corrected: tk.enum.corrected,
  Settled: tk.enum.settled,
  Cancelled: tk.enum.cancelled,
  Withdrawn: tk.enum.withdrawn,
};

export enum CustomExceptionType {
  ProjectDelayed = 'ProjectDelayed',
}

export enum PackageTypeEnum {
  Purchase = 'Purchase',
  Sale = 'Sale',
}

export enum InvoiceTypeEnum {
  Foreign = 'Foreign',
  Domestic = 'Domestic',
}

export const InvoiceTypeObj = {
  Foreign: tk.enum.foreign,
  Domestic: tk.enum.domestic,
};

//SalesInvoice
export enum SalesInvoiceStatusEnum {
  Draft = 'Draft',
  Generated = 'Generated',
  Sent = 'Sent',
  InKSeF = 'InKSeF',
  Paid = 'Paid',
}

export const SalesInvoiceStatusObj = {
  Draft: tk.enum.draft,
  Generated: tk.enum.generated,
  Sent: tk.enum.sentShe,
  InKSeF: tk.enum.inKSeF,
  Paid: tk.enum.paid,
};

export enum PaymentStatusEnum {
  Paid = 'Paid',
  PartiallyPaid = 'PartiallyPaid',
  Pending = 'Pending',
  Overdue = 'Overdue',
  OverduePartiallyPaid = 'OverduePartiallyPaid',
}

export const PaymentStatusObj = {
  Paid: tk.enum.paymentStatusPaid,
  PartiallyPaid: tk.enum.paymentStatusPartiallyPaid,
  Pending: tk.enum.paymentStatusPending,
  Overdue: tk.enum.paymentStatusOverdue,
  OverduePartiallyPaid: tk.enum.paymentStatusOverduePartiallyPaid,
};

export enum KSFStatusEnum {
  AcceptedInKSeF = 'AcceptedInKSeF',
  RejectedInKSeF = 'RejectedInKSeF',
  WaitingForKSeF = 'WaitingForKSeF',
  OFFLINE = 'OFFLINE',
}

export enum FilterInvoiceTypeEnum {
  PurchaseInvoice,
  SalesInvoice,
}

export enum PurchaseInvoiceStatusEnum {
  Open = 'Open',
  Approved = 'Approved',
  Sent = 'Sent',
}

export const PurchaseInvoiceStatusObj = {
  Open: tk.enum.open,
  Approved: tk.enum.approved,
  Sent: tk.enum.sentShe,
};

export enum PaymentFormEnum {
  BankTransfer = 'BankTransfer',
  Compensation = 'Compensation',
  Prepayment = 'Prepayment',
  Paid = 'Paid',
}

export enum PaymentFormEnumDe {
  BankTransfer = 'Überweisung',
  Compensation = 'Kompensation',
  Prepayment = 'Vorauszahlung',
  Paid = 'Bezahlt',
}

export enum PaymentFormEnumSymfoniaText {
  BankTransfer = 'przelew',
  Compensation = 'kompensata',
  Prepayment = 'przedpłata',
  Paid = 'zapłacono',
}

export enum PaymentFormEnumEnglishText {
  BankTransfer = 'payment',
  Compensation = 'compensation',
  Prepayment = 'prepayment',
  Paid = 'paid',
}

export const PaymentFormObj = {
  BankTransfer: tk.enum.bankTransfer,
  Compensation: tk.enum.compensation,
  Prepayment: tk.enum.prepayment,
  Paid: tk.enum.paidIt,
};

export enum OrderStatusEnum {
  New = 'New',
  Accepted = 'Accepted',
  Rejected = 'Rejected',
}

export const OrderStatusObj = {
  New: tk.enum.newPlural,
  Accepted: tk.enum.acceptedPlural,
  Rejected: tk.enum.rejectedPlural,
};

export enum OrderExecutionStatusEnum {
  New = 'New',
  Accepted = 'Accepted',
  Rejected = 'Rejected',
}

export const OrderExecutionStatusObj = {
  New: tk.enum.newPlural,
  Accepted: tk.enum.acceptedPlural,
  Rejected: tk.enum.rejectedPlural,
};

export enum AttachmentObjectType {
  Budget = 'Budget',
  Project = 'Project',
  PurchaseInvoice = 'PurchaseInvoice',
  EstimateItemCommentMediaplanner = 'EstimateItemCommentMediaplanner',
  EstimateItemCommentFinance = 'EstimateItemCommentFinance',
  EstimateByMonthMediaplanner = 'EstimateByMonthMediaplanner',
  EstimateByMonthFinance = 'EstimateByMonthFinance',
  Contract = 'Contract',
  SignedContract = 'SignedContract',
  EmployeeSign = 'EmployeeSign',
  SalesInvoice = 'SalesInvoice',
  SentEmail = 'SentEmail',
}

export const AttachmentObjectTypeObj = {
  Budget: tk.enum.budget,
  Project: tk.enum.project,
  PurchaseInvoice: tk.enum.purchaseInvoice,
  EstimateItemCommentMediaplanner: tk.enum.estimateItemCommentMediaplanner,
  EstimateItemCommentFinance: tk.enum.estimateItemCommentFinance,
  EstimateByMonthMediaplanner: tk.enum.estimateByMonthMediaplanner,
  EstimateByMonthFinance: tk.enum.estimateByMonthFinance,
  Contract: tk.enum.contract,
  SignedContract: tk.enum.signedContract,
  EmployeeSign: tk.enum.employeeSign,
  SalesInvoice: tk.enum.salesInvoice,
  SentEmail: tk.enum.sentEmail,
};

export enum AttachmentAutomaticDescriptionEnum {
  StatusReversal = 'StatusReversal',
  AutomaticOperation = 'AutomaticOperation',
}

export const AttachmentAutomaticDescriptionObj = {
  StatusReversal: tk.enum.statusReversal,
  AutomaticOperation: tk.enum.automaticOperation,
};

export enum AttachmentAutomaticNoteEnum {
  AutomaticallyApproved = 'AutomaticallyApproved',
  RevertFromApproved = 'RevertFromApproved',
  RevertFromSent = 'RevertFromSent',
}

export const AttachmentAutomaticNoteObj = {
  AutomaticallyApproved: tk.enum.automaticallyApproved,
  RevertFromApproved: tk.enum.revertFromApproved,
  RevertFromSent: tk.enum.revertFromSent,
};

export enum PdfTemplateType {
  Invoice = 'Invoice',
  InvoiceEng = 'InvoiceEng',
  InvoiceCorrection = 'InvoiceCorrection',
  InvoiceCorrectionEng = 'InvoiceCorrectionEng',
  InvoiceDataPrintout = 'InvoiceDataPrintout',
  OrderConfirmation = 'OrderConfirmation',
}

export enum EmailTemplateType {
  Order = 'Order',
  OrderExecution = 'OrderExecution',
  Application = 'Application',
  ApplicationExecution = 'ApplicationExecution',
  Project = 'Project',
  ProjectCancel = 'ProjectCancel',
  UnblockEstimate = 'UnblockEstimate',
  PurchaseDeficiencies = 'PurchaseDeficiencies',
  SpecialInvoicing = 'SpecialInvoicing',
  UnsettledInvoices = 'UnsettledInvoices',
  DelayedInvoices = 'DelayedInvoices',
  SalesInvoicing = 'SalesInvoicing',
  PurchaserCreatedInOrder = 'PurchaserCreatedInOrder',
  PurchaserEditedInOrder = 'PurchaserEditedInOrder',
  TooManyPurchasersInOrder = 'TooManyPurchasersInOrder',
  ContractImportError = 'ContractImportError',
  ContractsWaitingToSign = 'ContractsWaitingToSign',
  SignedContract = 'SignedContract',
  ProjectDateChange = 'ProjectDateChange',
  InvoiceToContractor = 'InvoiceToContractor',
  SurveyToClient = 'SurveyToClient',
  CyclicJobError = 'CyclicJobError',
  MirrorProject = 'MirrorProject',
  ExcelImport = 'ExcelImport',
}

export enum ApplicationUnblockStatusEnum {
  New = 'New',
  Accepted = 'Accepted',
  Rejected = 'Rejected',
}

export const ApplicationUnblockStatusObj = {
  New: tk.enum.new,
  Accepted: tk.enum.accepted,
  Rejected: tk.enum.rejected,
};

export enum ApplicationUnblockTypeEnum {
  Sales = 'Sales',
  Purchase = 'Purchase',
}

export const ApplicationUnblockTypeObj = {
  Sales: tk.enum.sales,
  Purchase: tk.enum.purchase,
};

export enum MemoSubjectType {
  Project = 'Project',
  PurchaseInvoice = 'PurchaseInvoice',
  SaleInvoice = 'SaleInvoice',
  SpecialInvoicing = 'SpecialInvoicing',
}

export const MemoSubjectTypeObj = {
  Project: tk.enum.projectNoun,
  PurchaseInvoice: tk.enum.purchaseInvoiceNoun,
  SaleInvoice: tk.enum.saleInvoiceNoun,
  SpecialInvoicing: tk.enum.specialInvoicingNoun,
};

export enum ProjectApplicationTypeEnum {
  Delayed = 'Delayed',
  ToCancel = 'ToCancel',
  DateChange = 'DateChange',
  All = 'All',
}

export const ProjectApplicationTypeEnumObj = {
  Delayed: tk.enum.delayed,
  ToCancel: tk.enum.toCancel,
  DateChange: tk.enum.dateChange,
  All: tk.enum.all,
};

export enum SpecialInvoicingStatus {
  New = 'New',
  Accepted = 'Accepted',
  Rejected = 'Rejected',
  ToBeCorrected = 'ToBeCorrected',
}

export const SpecialInvoicingStatusObj = {
  New: tk.enum.newPlural,
  Accepted: tk.enum.acceptedPlural,
  Rejected: tk.enum.rejectedPlural,
  ToBeCorrected: tk.enum.toBeCorrected,
};

export enum ExcelImportTypeEnum {
  Others = 'Others',
  TVBuying = 'TVBuying',
  MPC = 'MPC',
}

export const ExcelImportTypeObj = {
  Others: tk.enum.others,
  TVBuying: tk.enum.tvBuying,
  MPC: tk.enum.MPC,
};

export enum EmailConfigTypeEnum {
  Applications = 'Applications',
  PositionAppForeign = 'PositionAppForeign',
  ApplicationExecutions = 'ApplicationExecutions',
  Orders = 'Orders',
  OrdersRemind = 'OrdersRemind',
  OrderExecutions = 'OrderExecutions',
  OrderExecutionsRemind = 'OrderExecutionsRemind',
  UnblockEstimateByMonth = 'UnblockEstimateByMonth',
  ProjectsDelayed = 'ProjectsDelayed',
  ProjectsToCancel = 'ProjectsToCancel',
  PurchaseDeficiencies = 'PurchaseDeficiencies',
  SpecialInvoicing = 'SpecialInvoicing',
  SalesInvoicing = 'SalesInvoicing',
  PurchaserCreatedInOrder = 'PurchaserCreatedInOrder',
  PurchaserEditedInOrder = 'PurchaserEditedInOrder',
  TooManyPurchasersInOrder = 'TooManyPurchasersInOrder',
  ContractImportError = 'ContractImportError',
  ContractsWaitingToSign = 'ContractsWaitingToSign',
  ProjectDateChange = 'ProjectDateChange',
  CyclicJobError = 'CyclicJobError',
  MirrorProject = 'MirrorProject',
}

export const EmailConfigTypeObj = {
  Applications: tk.enum.applications,
  PositionAppForeign: tk.enum.positionAppForeign,
  ApplicationExecutions: tk.enum.applicationExecutions,
  Orders: tk.enum.orders,
  OrdersRemind: tk.enum.ordersRemind,
  OrderExecutions: tk.enum.orderExecutions,
  OrderExecutionsRemind: tk.enum.orderExecutionsRemind,
  UnblockEstimateByMonth: tk.enum.unblockEstimateByMonth,
  ProjectsDelayed: tk.enum.projectsDelayed,
  ProjectsToCancel: tk.enum.projectsToCancel,
  PurchaseDeficiencies: tk.enum.purchaseDeficiencies,
  SpecialInvoicing: tk.enum.specialInvoicing,
  SalesInvoicing: tk.enum.salesInvoicing,
  PurchaserCreatedInOrder: tk.enum.purchaserCreatedInOrder,
  PurchaserEditedInOrder: tk.enum.purchaserEditedInOrder,
  TooManyPurchasersInOrder: tk.enum.tooManyPurchasersInOrder,
  ContractImportError: tk.enum.contractImportError,
  ContractsWaitingToSign: tk.enum.contractsWaitingToSign,
  ProjectDateChange: tk.enum.projectDateChange,
  CyclicJobError: tk.enum.cyclicJobError,
  MirrorProject: tk.enum.mirrorProject,
};

export enum ExcelImportStatusEnum {
  OK = 'OK',
  Error = 'Error',
  Duplicate = 'Duplicate',
}

export const ExcelImportStatusObj = {
  OK: tk.enum.ok,
  Error: tk.enum.error,
  Duplicate: tk.enum.duplicate,
};

export enum JobTypeEnum {
  OrderExecutionReminder = 'OrderExecutionReminder',
  OrderReminder = 'OrderReminder',
  DailyFVZReminder = 'DailyFVZReminder',
  WeekFVZReminder = 'WeekFVZReminder',
  ExternalContractsImport = 'ExternalContractsImport',
  DeleteBlockadeMonthException = 'DeleteBlockadeMonthException',
  WaitingContractsToSign = 'WaitingContractsToSign',
  ReportEstimateItemsDataRawToGoogleDrive = 'ReportEstimateItemsDataRawToGoogleDrive',
  EodClients = 'EodClients',
  EodDocuments = 'EodDocuments',
  ImportKSeFFromSymphonyHandel = 'ImportKSeFFromSymphonyHandel',
  ExportSalesInvoicesToSymphony = 'ExportSalesInvoicesToSymphony',
  GenerateSurveyForClients = 'GenerateSurveyForClients',
  SendSurveyToClients = 'SendSurveyToClients',
  BackupSurowkaToGoogleDrive = 'BackupSurowkaToGoogleDrive',
  RefreshSalesInvoicePayments = 'RefreshSalesInvoicePayments',
  SyncFromOneTool = 'SyncFromOneTool',
}

export const JobTypeObj = {
  OrderExecutionReminder: tk.enum.orderExecutionReminder,
  OrderReminder: tk.enum.orderReminder,
  DailyFVZReminder: tk.enum.dailyFVZReminder,
  WeekFVZReminder: tk.enum.weekFVZReminder,
  ExternalContractsImport: tk.enum.externalContractsImport,
  DeleteBlockadeMonthException: tk.enum.deleteBlockadeMonthException,
  WaitingContractsToSign: tk.enum.waitingContractsToSign,
  ReportEstimateItemsDataRawToGoogleDrive:
    tk.enum.reportEstimateItemsDataRawToGoogleDrive,
  EodClients: tk.enum.eodClients,
  EodDocuments: tk.enum.eodDocuments,
  ImportKSeFFromSymphonyHandel: tk.enum.importKSeFFromSymphonyHandel,
  ExportSalesInvoicesToSymphony: tk.enum.exportSalesInvoicesToSymphony,
  GenerateSurveyForClients: tk.enum.generateSurveyForClients,
  SendSurveyToClients: tk.enum.sendSurveyToClients,
  BackupSurowkaToGoogleDrive: tk.enum.backupSurowkaToGoogleDrive,
  RefreshSalesInvoicePayments: tk.enum.refreshSalesInvoicePayments,
  SyncFromOneTool: tk.enum.syncFromOneTool,
};

export enum TemplateTypeEnum {
  Poland = 'Poland',
  UnitedStates = 'UnitedStates',
  Germany = 'Germany',
}

export const TemplateTypeObj = {
  Poland: tk.enum.poland,
  UnitedStates: tk.enum.unitedStates,
  Germany: tk.enum.germany,
};

export enum VatEnum {
  '23%' = '23%',
  '19%' = '19%',
  '8%' = '8%',
  '5%' = '5%',
  '4%' = '4%',
  '0%' = '0%',
  'zw.' = 'zw.',
  'np.' = 'np.',
}

export enum ContractStatusEnum {
  Entered = 'Entered',
  WaitingForSigning = 'WaitingForSigning',
  Signed = 'Signed',
  Unsigned = 'Unsigned',
  Sent = 'Sent',
}

export const ContractStatusObj = {
  Entered: tk.enum.entered,
  WaitingForSigning: tk.enum.waitingForSigning,
  Signed: tk.enum.signed,
  Unsigned: tk.enum.unsigned,
  Sent: tk.enum.sent,
};

export enum FiltrYearTypeEnum {
  DateOfIssue = 'DateOfIssue',
  DateOfSale = 'DateOfSale',
  DateOfProject = 'DateOfProject',
}

export const FiltrYearTypeObj = {
  DateOfIssue: tk.enum.dateOfIssue,
  DateOfSale: tk.enum.dateOfSale,
  DateOfProject: tk.enum.dateOfProject,
};

export enum EntityTypeEnum {
  SalesInvoice = 'SalesInvoice',
  ClientSurvey = 'ClientSurvey',
}

export enum SentEmailTypeEnum {
  SalesInvoiceToContractor = 'SalesInvoiceToContractor',
  SalesInvoiceDuplicateToContractor = 'SalesInvoiceDuplicateToContractor',
  SurveyToClient = 'SurveyToClient',
  ExcelImport = 'ExcelImport',
  Applications = 'Applications',
  PositionAppForeign = 'PositionAppForeign',
  ApplicationExecutions = 'ApplicationExecutions',
  Orders = 'Orders',
  OrdersRemind = 'OrdersRemind',
  OrderExecutions = 'OrderExecutions',
  OrderExecutionsRemind = 'OrderExecutionsRemind',
  UnblockEstimateByMonth = 'UnblockEstimateByMonth',
  PurchaserCreatedInOrder = 'PurchaserCreatedInOrder',
  PurchaserEditedInOrder = 'PurchaserEditedInOrder',
  TooManyPurchasersInOrder = 'TooManyPurchasersInOrder',
  ProjectDelayed = 'ProjectDelayed',
  ProjectToCancel = 'ProjectToCancel',
  ProjectDateChange = 'ProjectDateChange',
  PurchaseDeficiencies = 'PurchaseDeficiencies',
  SalesInvoicing = 'SalesInvoicing',
  SpecialInvoicing = 'SpecialInvoicing',
  ContractImportError = 'ContractImportError',
  ContractsWaitingToSign = 'ContractsWaitingToSign',
  SignedContracts = 'SignedContracts',
  CyclicJobError = 'CyclicJobError',
  FVZTeamReminder = 'FVZTeamReminder',
  NoPurchaserInOrder = 'NoPurchaserInOrder',
  MirrorProject = 'MirrorProject',
  MirrorProjectError = 'MirrorProjectError',
}

export const SentEmailTypeObj = {
  SalesInvoiceToContractor: tk.enum.salesInvoiceToContractor,
  SalesInvoiceDuplicateToContractor: tk.enum.salesInvoiceDuplicateToContractor,
  SurveyToClient: tk.enum.surveyToClient,
  ExcelImport: tk.enum.excelImport,
  Applications: tk.enum.applications,
  PositionAppForeign: tk.enum.positionAppForeign,
  ApplicationExecutions: tk.enum.applicationExecutions,
  Orders: tk.enum.orders,
  OrdersRemind: tk.enum.ordersRemind,
  OrderExecutions: tk.enum.orderExecutions,
  OrderExecutionsRemind: tk.enum.orderExecutionsRemind,
  UnblockEstimateByMonth: tk.enum.unblockEstimateByMonth,
  PurchaserCreatedInOrder: tk.enum.purchaserCreatedInOrder,
  PurchaserEditedInOrder: tk.enum.purchaserEditedInOrder,
  TooManyPurchasersInOrder: tk.enum.tooManyPurchasersInOrder,
  ProjectDelayed: tk.enum.projectsDelayed,
  ProjectToCancel: tk.enum.projectsToCancel,
  ProjectDateChange: tk.enum.projectDateChange,
  PurchaseDeficiencies: tk.enum.purchaseDeficiencies,
  SalesInvoicing: tk.enum.salesInvoicing,
  SpecialInvoicing: tk.enum.specialInvoicing,
  ContractImportError: tk.enum.contractImportError,
  ContractsWaitingToSign: tk.enum.contractsWaitingToSign,
  SignedContracts: tk.enum.signedContracts,
  CyclicJobError: tk.enum.cyclicJobError,
  FVZTeamReminder: tk.enum.fvzTeamReminder,
  MirrorProject: tk.enum.mirrorProject,
  MirrorProjectError: tk.enum.mirrorProjectError,
  NoPurchaserInOrder: tk.enum.noPurchaserInOrder,
};

export enum ParamsTypeEnum {
  String = 'String',
  Boolean = 'Boolean',
  Number = 'Number',
  Date = 'Date',
}

export enum EodDocumentStatusEnum {
  WaitingForPokImport = 1,
  ImportedByPok = 2,
  ProcessedByPok = 3, // Nowa dekretacja wystawiona przez POK
  DecreeImportedByEod = 4,
  InvoiceInFK = 5,
  PokImportError = 6,
  EodImportError = 7,
  WaitingForEodImport = 8,
  ImportedByEod = 9,
  EodImportFromPokError = 10,
  CancelledByPok = 11,
  CancelledByPokInEod = 13,
}

export const EodDocumentStatusObj = {
  [EodDocumentStatusEnum.WaitingForPokImport]: 'Oczekuje na pobranie przez POK',
  [EodDocumentStatusEnum.ImportedByPok]:
    'Pobrane przez POK - ustawiane przez POK',
  [EodDocumentStatusEnum.ProcessedByPok]:
    'Obsłużone przez POK - ustawione przez POK', // Nowa dekretacja wystawiona przez POK
  [EodDocumentStatusEnum.DecreeImportedByEod]:
    'Dekret pobrany przez EOD - ustawiane przez EOD',
  [EodDocumentStatusEnum.InvoiceInFK]: 'Faktura w FK - ustawiane przez EOD',
  [EodDocumentStatusEnum.PokImportError]: 'Błąd podczas importu do POK',
  [EodDocumentStatusEnum.EodImportError]: 'Błąd podczas importu do EOD',
  [EodDocumentStatusEnum.WaitingForEodImport]:
    'Oczekuje na pobranie FV przez EOD',
  [EodDocumentStatusEnum.ImportedByEod]:
    'FVZ pobrana przez EOD - ustawiane przez EOD',
  [EodDocumentStatusEnum.EodImportFromPokError]:
    'Błąd podczas importu dokumentu do EOD z bazy wymiany',
  [EodDocumentStatusEnum.CancelledByPok]: 'Dokument anulowany przez POK',
  [EodDocumentStatusEnum.CancelledByPokInEod]:
    'Potwierdzenie statusu anulowania po stronie EOD',
};

export enum EodPaidStatusEnum {
  WaitingForPokImport = 1,
  ImportedByPok = 2,
}

export const EodPaidStatusObj = {
  [EodDocumentStatusEnum.WaitingForPokImport]: 'Oczekuje na pobranie przez POK',
  [EodDocumentStatusEnum.ImportedByPok]:
    'Pobrane przez POK - ustawiane przez POK',
};

export enum ParamsNameEnum {
  LastProcessedDocumentsDate = 'LastProcessedDocumentsDate',
  LastProcessedClientsDate = 'LastProcessedClientsDate',
  TurnOffPurchaseInvoiceDomestic = 'TurnOffPurchaseInvoiceDomestic',
  DaysToCancelFVZNumber = 'DaysToCancelFVZNumber',
  UMPRequestUserForDebug = 'UMPRequestUserForDebug',
  UMPLogs = 'UMPLogs',
  NewPositionApplicationUrl = 'NewPositionApplicationUrl',
  SurowkaFromYear = 'SurowkaFromYear',
  SurowkaBaseName = 'SurowkaBaseName',
  SurowkaBackupSubfolder = 'SurowkaBackupSubfolder',
  MirrorProjectResponsibleUser = 'MirrorProjectResponsibleUser',
  ContractsForWorkUrl = 'ContractsForWorkUrl',
  SurveyEmailMessagePl = 'SurveyEmailMessagePl',
  SurveyEmailMessageEng = 'SurveyEmailMessageEng',
  MediaplannerApiProjectsByTeamsForCompanies = 'MediaplannerApiProjectsByTeamsForCompanies',
  MirrorProjectProfileName = 'MirrorProjectProfileName',
  MirrorProjectCompanySysNumber = 'MirrorProjectCompanySysNumber',
  MirrorProjectTeamSysNumber = 'MirrorProjectTeamSysNumber',
}

export const ParamsNameObj = {
  LastProcessedDocumentsDate: tk.param.lastProcessedDocumentsDate,
  LastProcessedClientsDate: tk.param.lastProcessedClientsDate,
  TurnOffPurchaseInvoiceDomestic: tk.param.turnOffPurchaseInvoiceDomestic,
  DaysToCancelFVZNumber: tk.param.daysToCancelFVZNumber,
  UMPRequestUserForDebug: tk.param.umpRequestUserForDebug,
  UMPLogs: tk.param.umpLogs,
  NewPositionApplicationUrl: tk.param.newPositionApplicationUrl,
  SurowkaFromYear: tk.param.surowkaFromYear,
  SurowkaBaseName: tk.param.surowkaBaseName,
  SurowkaBackupSubfolder: tk.param.surowkaBackupSubfolder,
  MirrorProjectResponsibleUser: tk.param.mirrorProjectResponsibleUser,
  ContractsForWorkUrl: tk.param.contractsForWorkUrl,
  SurveyEmailMessagePl: tk.param.surveyEmailMessagePl,
  SurveyEmailMessageEng: tk.param.surveyEmailMessageEng,
  MediaplannerApiProjectsByTeamsForCompanies:
    tk.param.mediaplannerApiProjectsByTeamsForCompanies,
  MirrorProjectProfileName: tk.param.mirrorProjectProfileName,
  MirrorProjectCompanySysNumber: tk.param.mirrorProjectCompanySysNumber,
  MirrorProjectTeamSysNumber: tk.param.mirrorProjectTeamSysNumber,
};

export enum ParamsGroupEnum {
  EOD = 'EOD',
  FVZ = 'FVZ',
  UMP = 'UMP',
  SYS = 'SYS',
  Surowka = 'Surowka',
  API = 'API',
  MirrorProject = 'MirrorProject',
}

export const ParamsGroupObj = {
  EOD: tk.param.eod,
  FVZ: tk.param.fvz,
  UMP: tk.param.ump,
  SYS: tk.param.system,
  Surowka: tk.param.surowka,
  API: tk.param.api,
  MirrorProject: tk.param.mirrorProject,
};

export enum RecommendedPublisherScopeEnum {
  Global = 'Global',
  Company = 'Company',
  Purchaser = 'Purchaser',
}

export const RecommendedPublisherScopeObj = {
  Global: tk.enum.scopeGlobal,
  Company: tk.enum.scopeCompany,
  Purchaser: tk.enum.scopePurchaser,
};

export enum TimelineStageEnum {
  CampaignCompletion = 'CampaignCompletion',
  Contracts = 'Contracts',
  IntercompanyOrders = 'IntercompanyOrders',
  CampaignSettlement = 'CampaignSettlement',
}

export const TimelineStageObj = {
  CampaignCompletion: tk.enum.campaignCompletion,
  Contracts: tk.enum.contracts,
  IntercompanyOrders: tk.enum.intercompanyOrders,
  CampaignSettlement: tk.enum.campaignSettlement,
};

export enum TimelineStageStatusEnum {
  NotStarted = 'NotStarted',
  InProgress = 'InProgress',
  Error = 'Error',
  Completed = 'Completed',
  NotApplicable = 'NotApplicable',
}
export const TimelineStageStatusObj = {
  NotStarted: tk.enum.notStarted,
  InProgress: tk.enum.inProgress,
  Error: tk.enum.timelineError,
  Completed: tk.enum.completed,
  NotApplicable: tk.enum.notApplicable,
};

export enum TimelineHintDeadlineEnum {
  SinceProjectCreation = 'SinceProjectCreation',
  LastMonthEnd = 'LastMonthEnd',
  FifteenthOfCurrentMonth = 'FifteenthOfCurrentMonth',
  CurrentMonthEnd = 'CurrentMonthEnd',
  FifteenthOfNextMonth = 'FifteenthOfNextMonth',
  NextMonthEnd = 'NextMonthEnd',
}

export const TimelineHintDeadlineObj = {
  SinceProjectCreation: tk.enum.sinceProjectCreation,
  LastMonthEnd: tk.enum.lastMonthEnd,
  FifteenthOfCurrentMonth: tk.enum.fifteenthOfCurrentMonth,
  CurrentMonthEnd: tk.enum.currentMonthEnd,
  FifteenthOfNextMonth: tk.enum.fifteenthOfNextMonth,
  NextMonthEnd: tk.enum.nextMonthEnd,
};

export enum QuestionResponseTypeEnum {
  Text = 'Text',
  YesNo = 'YesNo',
  YesNoText = 'YesNoText',
}

export const QuestionResponseTypeObj = {
  Text: tk.enum.text,
  YesNo: tk.enum.yesNo,
  YesNoText: tk.enum.yesNoText,
};

export enum SurveyFrequencyEnum {
  OnceAYear = 'OnceAYear',
  SemiAnnually = 'SemiAnnually',
  Quarterly = 'Quarterly',
  Monthly = 'Monthly',
}

export const SurveyFrequencyObj = {
  OnceAYear: tk.enum.onceAYear,
  SemiAnnually: tk.enum.semiAnnually,
  Quarterly: tk.enum.quarterly,
  Monthly: tk.enum.monthly,
};

export enum ContractorTypeEnum {
  All = 'All',
  Purchaser = 'Purchaser',
  Supplier = 'Supplier',
  Group = 'Group',
}

export const ContractorTypeObj = {
  All: tk.enum.allShe,
  Purchaser: tk.enum.purchaserShort,
  Supplier: tk.enum.supplier,
  Group: tk.enum.clientsGroup,
};

export enum YesNoEnum {
  Yes = 'Yes',
  No = 'No',
}

export const YesNoObj = {
  Yes: tk.enum.yes,
  No: tk.enum.no,
};

export enum TimelineStepPriorityEnum {
  High = 'High',
  Medium = 'Medium',
  Low = 'Low',
}

export const TimelineStepPriorityObj = {
  High: tk.enum.high,
  Medium: tk.enum.medium,
  Low: tk.enum.low,
};

export enum TimelineStepEnum {
  // Etap: CampaignCompletion - Uzupełnienie kampanii
  AtLeastOneProfilePerMonth = 'AtLeastOneProfilePerMonth',
  NoMediaplanForMediaProfileInCurrentMonth = 'NoMediaplanForMediaProfileInCurrentMonth',
  AtLeastOneItemAdded = 'AtLeastOneItemAdded',
  MediaplanApprovedByClient = 'MediaplanApprovedByClient',
  AllItemsWithAmountsEnteredForCurrentMonth = 'AllItemsWithAmountsEnteredForCurrentMonth',
  RequiredCampaignDocumentsAdded = 'RequiredCampaignDocumentsAdded',
  CurrentMonthReadyForInvoicing = 'CurrentMonthReadyForInvoicing',

  // Etap: Request - Wnioski
  SpecialInvoicingRequest = 'SpecialInvoicingRequest',
  ProjectCancelledRequest = 'ProjectCancelledRequest',
  ProjectDateChangeRequest = 'ProjectDateChangeRequest',

  // Etap: Contracts - Zlecenia
  CheckContractsCoverage = 'CheckContractsCoverage',
  ContractsSignedByResponsiblePerson = 'ContractsSignedByResponsiblePerson',
  NoContract = 'NoContract',
  ContractSent = 'ContractSent',

  // Etap: IntercompanyOrders - Zamówienia międzyspółkowe
  OrderCreatedForSpecialistTeam = 'OrderCreatedForSpecialistTeam',
  OrderApprovedBySpecialistTeam = 'OrderApprovedBySpecialistTeam',
  OrderExecutionCreated = 'OrderExecutionCreated',
  OrderExecutionApproved = 'OrderExecutionApproved',
  OrderExecutionPositionsSumValidation = 'OrderExecutionPositionsSumValidation',

  // Etap: CampaignSettlement - Rozliczenie kampanii
  MonthlySettlementReminder = 'MonthlySettlementReminder',

  StatusConfirmedByDocuments = 'StatusConfirmedByDocuments',
  SalesSettlementCompleted = 'SalesSettlementCompleted',
  PendingFVZAssignedToCampaign = 'PendingFVZAssignedToCampaign',
  MissingFVZ = 'MissingFVZ',
  PurchaseSettlementCompleted = 'PurchaseSettlementCompleted',
  CampaignsWithBlockingInvoicingErrors = 'CampaignsWithBlockingInvoicingErrors',
  SalesInvoiceSent = 'SalesInvoiceSent',
  MediaplanCorrection = 'MediaplanCorrection',
}

export const TimelineStepEnumObj = {
  // Etap: CampaignCompletion - Uzupełnienie kampanii
  AtLeastOneProfilePerMonth: tk.enum.atLeastOneProfilePerMonth,
  NoMediaplanForMediaProfileInCurrentMonth:
    tk.enum.noMediaplanForMediaProfileInCurrentMonth,
  AtLeastOneItemAdded: tk.enum.atLeastOneItemAdded,
  MediaplanApprovedByClient: tk.enum.mediaplanApprovedByClient,
  AllItemsWithAmountsEnteredForCurrentMonth:
    tk.enum.allItemsWithAmountsEnteredForCurrentMonth,
  RequiredCampaignDocumentsAdded: tk.enum.requiredCampaignDocumentsAdded,
  CurrentMonthReadyForInvoicing: tk.enum.currentMonthReadyForInvoicing,

  // Etap: Request - Wnioski
  SpecialInvoicingRequest: tk.enum.specialInvoicingRequest,
  ProjectCancelledRequest: tk.enum.projectCancelledRequest,
  ProjectDateChangeRequest: tk.enum.projectDateChangeRequest,

  // Etap: Contracts - Zlecenia
  CheckContractsCoverage: tk.enum.checkContractsCoverage,
  ContractsSignedByResponsiblePerson:
    tk.enum.contractsSignedByResponsiblePerson,
  NoContract: tk.enum.noContract,
  ContractSent: tk.enum.contractSent,

  // Etap: IntercompanyOrders - Zamówienia międzyspółkowe
  OrderCreatedForSpecialistTeam: tk.enum.orderCreatedForDeliveryTeam,
  OrderApprovedBySpecialistTeam: tk.enum.orderApprovedByDeliveryTeam,
  OrderExecutionCreated: tk.enum.orderExecutionCreated,
  OrderExecutionApproved: tk.enum.orderExecutionApproved,
  OrderExecutionPositionsSumValidation:
    tk.enum.orderExecutionPositionsSumValidation,

  // Etap: CampaignSettlement - Rozliczenie kampanii
  MonthlySettlementReminder: tk.enum.monthlySettlementReminder,

  StatusConfirmedByDocuments: tk.enum.statusConfirmedByDocuments,
  SalesSettlementCompleted: tk.enum.salesSettlementCompleted,
  PendingFVZAssignedToCampaign: tk.enum.pendingFVZAssignedToCampaign,
  MissingFVZ: tk.enum.missingFVZ,
  PurchaseSettlementCompleted: tk.enum.purchaseSettlementCompleted,
  CampaignsWithBlockingInvoicingErrors:
    tk.enum.campaignsWithBlockingInvoicingErrors,
  SalesInvoiceSent: tk.enum.salesInvoiceSent,

  // Etap: CampaignCorrection - Korekta kampanii
  MediaplanCorrection: tk.enum.mediaplanCorrection,
};

export enum StepErrorLevelEnum {
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
  RequestInfo = 'requestInfo',
  RequestError = 'requestError',
  Future = 'future',
  NotApplicable = 'notApplicable',
}

export enum StepStatusEnum {
  Skip = 'skip',
  Incomplete = 'incomplete',
  Ok = 'ok',
}

export enum TimelineStageColor {
  Teal = 'teal',
  Blue = 'blue',
  Red = 'red',
  Gray = 'gray',
  Purple = 'purple',
  Black = 'black',
}
